import '@shui/core/sh-radio-button';

import { Component, booleanAttribute, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-radio-group',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.horizontal]': 'horizontal() ? "" : null'
    }
})
export class ShRadioGroupComponent {
    /**
     * Defines if a radio button direction by defauly direction is vertical. If true, direction is
     * set to horizontal.
     */
    public readonly horizontal = input(false, { transform: booleanAttribute });
}
